<script lang="ts">
  import { userContext } from '#lib/context.svelte.ts';
  import { ServerProblemDesc, type ServerProblem } from '#lib/internal/server_problem.ts';
  import { ignore } from '@yp/common/async.ts';
  import { isPresent, pare } from '@yp/common/identity.ts';
  import { normalizePhoneNumber } from '@yp/common/identity/phone.ts';
  import { Seconds } from '@yp/common/units.ts';
  import { reportError } from '@yp/web.app/client/errors.ts';
  import { PwaInstaller } from '@yp/web.app/client/pwa/install.ts';
  import { makeCallback } from '@yp/web.app/context.ts';
  import { Icon } from '@yp/web.app/gui/index.ts';
  import { post } from '@yp/web.app/gui/prompts.svelte.ts';
  import { userSignOut } from '@yp/web.firebase/client/auth.ts';
  import { createDialog } from 'svelte-headlessui';
  import Transition from 'svelte-transition';
  import { CanInstall } from '../../config/index.ts';

  const uctx = userContext();
  export let version: string | undefined = undefined;

  async function serverTest() {
    const prompt: Partial<ServerProblem> = pare({ delay: Seconds(3) });
    const result = await post('This will only take a moment...', {
      form: { value: prompt, desc: ServerProblemDesc, action: 'serverTest', actionUrl: '/' },
    });
    console.log('serverTest', { result });
    if (isPresent(prompt.error) && prompt.error.trim().length) {
      await reportError(new Error(prompt.error), { extra: { data: 'This is a test' } });
    }
  }

  // const navControl = createDisclosure({ label: 'Navigation', expanded: false });
  const navMenu = createDialog({ label: 'Menu' });

  $: user = {
    name: uctx.name,
    email: uctx.user?.email,
    mobile: uctx.user?.phoneNumber,
    // imageUrl:
    //   'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  };
  // $: me = $Me.data();
  // $: {
  //   if (!$Session?.user && $navControl.expanded) {
  //     navControl.close();
  //   }
  // }

  // const appNavigation = [
  //   { name: 'Dashboard', href: '#', current: true },
  //   { name: 'Team', href: '#', current: false },
  //   { name: 'Projects', href: '#', current: false },
  //   { name: 'Calendar', href: '#', current: false },
  //   { name: 'Reports', href: '#', current: false },
  // ];

  const signIn = makeCallback('signIn');

  $: menuNavigation = [
    {
      header: undefined,
      active: true,
      items: [
        // { name: 'Your Profile', href: '#' },
        // { name: 'Settings', href: '#' },
        { active: uctx.isLoggedIn, name: 'Sign out', icon: 'person_off', onClick: userSignOut },
        { active: !uctx.isLoggedIn, name: 'Sign In', icon: 'person', onClick: signIn },
        {
          active: $CanInstall,
          name: 'Install',
          icon: 'install_mobile',
          onClick: () => PwaInstaller.instance().install(),
        },
        // {
        //   active: true,
        //   name: 'Leave Feedback',
        //   icon: 'comment',
        //   onClick: () => reportIssue(uid),
        // },
      ],
    },
    {
      header: 'Admin',
      active: uctx.isAdmin,
      items: [
        {
          active: true,
          name: 'Test: Simulate Server Problem',
          icon: 'speed',
          onClick: serverTest,
        },
      ],
    },
  ];
</script>

<nav>
  <!-- Toolbar -->
  <div class="bg-primary text-primary-content mx-auto px-2 sm:px-4 lg:px-8 h-12">
    <div class="relative flex h-12 items-center justify-between">
      <div class="flex items-center px-2 lg:px-0">
        <!-- App Logo -->
        <Icon icon="celebration" />
        <!-- <div class="shrink-0 w-8">
          <img class="block h-8 w-8" src={AppIcon} alt="Millies Loyalty Program" />
        </div> -->
        <div class="py-2 px-3 text-lg font-roboto">McBarron NYE Bash</div>
        <!-- Title -->
        <!-- <div class="text-white py-2 px-3 text-4xl font-funkydori">millie's</div> -->
        <!-- Navigation Tabs -->
        <!-- <div class="hidden lg:ml-10 lg:block">
          <div class="flex space-x-4">
            {#each appNavigation as item (item.name)}
              <a
                href={item.href}
                class={classNames(
                  item.current
                    ? 'bg-black/25 text-white'
                    : 'text-white hover:bg-white/25',
                  'rounded-md py-2 px-3 text-sm font-medium',
                )}
                aria-current={item.current ? 'page' : undefined}>
                {item.name}
              </a>
            {/each}
          </div>
        </div> -->
      </div>
      <!-- Search Bar -->
      <!-- <div class="flex flex-1 justify-center px-2 lg:ml-6 lg:justify-end">
        <div class="w-full max-w-lg lg:max-w-xs">
          <label for="search" class="sr-only"> Search </label>
          <div class="relative text-gray-400 focus-within:text-gray-600">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <MagnifyingGlassIcon class="h-5 w-5" aria-hidden="true" />
            </div>
            <input
              id="search"
              class="block w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-3 text-gray-900 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-m-dp sm:text-sm sm:leading-6"
              placeholder="Search"
              type="search"
              name="search" />
          </div>
        </div>
      </div> -->
      <!-- Sprinkles -->
      <!-- {#if $Session?.user}
        <div class="text-white hover:bg-white/25">
          Sprinkles: {me?.points ?? 0}
        </div>
      {/if} -->
      <!-- Mobile Menu Toggle -->
      <div class="flex">
        <button
          on:click={() => ($navMenu.expanded ? navMenu.close() : navMenu.open())}
          class="relative inline-flex items-center justify-center rounded-md bg-white/10 p-2 hover:bg-white/25 hover:text-white focus:outline-hidden focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-m-dp">
          <span class="absolute -inset-0.5" />
          <span class="sr-only">Open main menu</span>
          <Icon icon={$navMenu.expanded ? 'close' : 'menu'} class="block" />
        </button>
      </div>
      <!-- ProfileMenu -->
      <!-- {:else}
        <button
          type="button"
          class="text-white hover:bg-white/25 rounded-md py-2 px-3 text-sm font-medium"
          on:click={signIn}>
          Sign In
        </button>
      {/if} -->
    </div>
  </div>
  {#if user}
    <!-- Mobile Menu -->
    <div class="relative">
      <Transition show={$navMenu.expanded}>
        <Transition
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <button class="fixed inset-0" on:click={navMenu.close}>
            <div class="w-full h-full bg-black/50" />
          </button>
        </Transition>
        <Transition
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scaley-95"
          enterTo="transform opacity-100 scaley-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scaley-100"
          leaveTo="transform opacity-0 scaley-95">
          <div class="absolute text-base-content bg-base-200 w-full">
            <div class="border-t border-black border-black/25">
              <ul role="list" class="flex flex-1 flex-col gap-y-4 px-6 py-4">
                {#if isPresent(user.name ?? user.email ?? user.mobile)}
                  <!-- Mobile Profile Panel-->
                  <li>
                    <div class="flex items-center">
                      <div class="shrink-0">
                        <Icon icon="person" filled={true} size={8} />
                      </div>
                      <div class="ml-3">
                        {#if user.name}
                          <div class="text-white font-bold">{user.name}</div>
                        {/if}
                        {#if user.email}
                          <div class="text-md font-medium">{user.email}</div>
                        {:else if user.mobile}
                          <div class="text-md font-medium">{normalizePhoneNumber(user.mobile)}</div>
                        {/if}
                      </div>
                    </div>
                  </li>
                {/if}
                {#each menuNavigation.filter((s) => s.active) as section}
                  {#if section.header}
                    <li>
                      <div class="text-xs text-left -mb-4">{section.header}</div>
                    </li>
                  {/if}
                  <li>
                    <ul role="list" class="-mx-2 space-y-1">
                      <!-- Mobile "Menu", although we don't apply pop-up menu semantics -->
                      <!-- <div class="mx-1.5 mt-3 space-y-1 px-2 flex flex-col"> -->
                      {#each section.items.filter((m) => m.active) as item (item.name)}
                        <li>
                          <button
                            type="button"
                            on:click={() => {
                              navMenu.close();
                              ignore(item.onClick());
                            }}
                            class="w-full block rounded-md px-3 py-2 text-base font-medium hover:bg-white/25 flex items-center">
                            {#if item.icon}<Icon icon={item.icon} />{/if}
                            <span class="ml-3">{item.name}</span>
                          </button>
                        </li>
                      {/each}
                      <!-- </div> -->
                    </ul>
                  </li>
                {/each}
                {#if version}
                  <li>
                    <div class="text-xs text-right text-base-content">
                      <div class="inline-block bg-base-100 py-1 px-2 rounded-md border-base-300">
                        <span>Version {version}</span><span class="ml-2 italic font-bold"
                          >Beta</span>
                      </div>
                    </div>
                  </li>
                {/if}
              </ul>
            </div>
          </div>
        </Transition>
      </Transition>
    </div>
  {/if}
</nav>
